import Image from 'next/image';
import { images } from '../../../Constants/ImageUrls';
import { Verified } from './styled';

export default function VerifiedTag(props) {
  const { wrapped, newSection } = props;
  return (
    <Verified wrapped={wrapped} newSection={newSection}>
      <Image
        src={images.checked}
        alt=""
        width={newSection ? 6 : 8}
        height={newSection ? 6 : 8}
      />
      <span className="verifiedBuyer">
        {newSection ? 'Verified' : 'Verified Buyer'}
      </span>
    </Verified>
  );
}
